module.exports = __webpack_public_path__ + "img/29_67.9ef4b046.png";